import NextStepsStep, { INextStepsStepPageContent } from './NextStepsStep.component';

export default NextStepsStep;
export type { INextStepsStepPageContent };
